import Vue from 'vue';
import initInterceptor from '../layoutid_RWJOB/common/interceptor';
import jobPage from './components/job-page.vue';
import vModal from './components/v-modal.vue';
import tabSlider from './common/tab-slider';
import youtubeEmbed from './applications/youtube-embed.vue';
import pageLoader from './applications/page-loader.vue';

initInterceptor();

/* eslint-disable no-new */
new Vue({
	el: '#rwjob-app',
	components: {
		jobPage,
		vModal,
		tabSlider,
		youtubeEmbed,
		pageLoader
	}
});
